/*!
 * (C) Phonero UX - ISC License
 */
import { i as isPlatform } from './platform-1c3ea0be.js';

function format(first, middle, last) {
  return (first || "") + (middle ? ` ${middle}` : "") + (last ? ` ${last}` : "");
}
const hostContext = (selector, el) => {
  return el.closest(selector) !== null;
};
const clamp = (min, n, max) => {
  return Math.max(min, Math.min(n, max));
};
/**
 * Create the mode and color classes for the component based on the classes passed in
 */
const createColorClasses = (color, kind = "pux-color") => {
  return typeof color === "string" && color.length > 0
    ? {
      [kind]: true,
      [`${kind}-${color}`]: true,
    }
    : undefined;
};
/** Sets a color for a pux-element
 *
 * If a function is used, it will return the current color of that element.
 * The return-value from the function is then treated as if it was the first argument.
 *
 * If a number is returned, it is treated as a color-index (with modulo), and use that color.
 * For negative numbers, it will remove the color-information from the element
 *
 * */
const experimentalSetPuxColor = (color, el) => {
  if (!el) {
    return;
  }
  const currentColor = ("color" in el && el.color) ||
    ("getAttribute" in el && el.getAttribute("color"));
  let _nextColor;
  const colorIndex = colors.indexOf(currentColor);
  if (typeof color === "function") {
    _nextColor = color(currentColor, colorIndex, el);
  }
  else {
    _nextColor = color;
  }
  if (_nextColor === currentColor) {
    return;
  }
  let nextColor;
  if (typeof _nextColor === "number") {
    if (_nextColor < 0) {
      nextColor = undefined;
    }
    else {
      nextColor = colors[_nextColor % colors.length];
    }
    console.log("numnum", _nextColor, nextColor);
  }
  else {
    nextColor = _nextColor;
  }
  for (const c of el.classList) {
    if (c.startsWith("pux-color-")) {
      el.classList.remove(c);
    }
  }
  if (!nextColor) {
    el.removeAttribute("color");
    return;
  }
  el.setAttribute("color", nextColor);
  const cls = createColorClasses(nextColor);
  for (const [c, enabled] of Object.entries(cls)) {
    if (!enabled) {
      continue;
    }
    el.classList.add(c);
  }
};
const colors = [
  "primary",
  "secondary",
  "dark",
  "medium",
  "light",
  "danger",
  "warning",
  "success",
  "tertiary",
  "summer",
  "orange-light",
  "orange-dark",
];
const getClassList = (classes) => {
  if (classes !== undefined) {
    const array = Array.isArray(classes) ? classes : classes.split(" ");
    return array
      .filter((c) => c != null)
      .map((c) => c.trim())
      .filter((c) => c !== "");
  }
  return [];
};
const getClassMap = (classes) => {
  const map = {};
  getClassList(classes).forEach((c) => (map[c] = true));
  return map;
};
const hasShadowDom = (el) => {
  return !!el.shadowRoot && !!el.attachShadow;
};
const findItemLabel = (componentEl) => {
  const { parentNode } = componentEl;
  if (parentNode && parentNode.tagName !== "PUX-ITEM") {
    const l = parentNode.querySelectorAll("label");
    if (l.length === 1) {
      return l[0];
    }
    const pl = parentNode.querySelectorAll("pux-label");
    if (pl.length === 1) {
      return pl[0];
    }
  }
  const itemEl = componentEl.closest("pux-item");
  if (itemEl) {
    return (itemEl.querySelector("label") ||
      itemEl.querySelector("pux-label"));
  }
  return null;
};
const debounceEvent = (event, wait) => {
  const original = event._original || event;
  return {
    _original: event,
    emit: debounce(original.emit.bind(original), wait),
  };
};
const debounce = (func, wait = 0) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(func, wait, ...args);
  };
};
const getElementRoot = (el, fallback = el) => {
  return el.shadowRoot || fallback;
};
const deepReady = async (el) => {
  const element = el;
  if (element) {
    if (element.componentOnReady != null) {
      const stencilEl = await element.componentOnReady();
      if (stencilEl != null) {
        return;
      }
    }
    await Promise.all(Array.from(element.children).map(deepReady));
  }
};
const blockSwipeBackEvent = (e) => {
  const DISABLE_SWIPE_BACK_EDGE = 27;
  const IGNORE = ["PUX-BUTTON"];
  const pageX = e.touches[0].pageX;
  const innerWidth = window.innerWidth;
  // is not near edge of view, exit
  if (pageX > DISABLE_SWIPE_BACK_EDGE &&
    pageX < innerWidth - DISABLE_SWIPE_BACK_EDGE)
    return;
  const tagName = e.target.tagName;
  // Ignore some tag-names i.e. close buttons that are often at the edge of the screen
  if (IGNORE.includes(tagName))
    return;
  // prevent swipe to navigate back gesture
  e.preventDefault();
  e.stopPropagation();
};
const setupKeyboardListeners = (windowHeight) => {
  if (isPlatform("mobile")) {
    if ("visualViewport" in window) {
      window["visualViewport"].addEventListener("resize", (event) => {
        if (event.target.height + 30 < windowHeight) {
          document.body.classList.add("keyboard-visible");
        }
        else {
          document.body.classList.remove("keyboard-visible");
        }
      });
    }
    else {
      console.info("Falling back to focus detection for keyboard events");
      const focusEventHandler = (e) => {
        const keyboardElements = ["INPUT", "TEXTAREA"];
        if (keyboardElements.includes(document.activeElement.tagName)) {
          document.body.classList.add("keyboard-visible");
        }
        else if (e.type == "focusout") {
          document.body.classList.remove("keyboard-visible");
        }
      };
      document.addEventListener("focusin", focusEventHandler);
      document.addEventListener("focusout", focusEventHandler);
    }
  }
};

export { createColorClasses as a, colors as b, clamp as c, getClassMap as d, experimentalSetPuxColor as e, format as f, getClassList as g, hostContext as h, hasShadowDom as i, findItemLabel as j, debounceEvent as k, debounce as l, getElementRoot as m, deepReady as n, blockSwipeBackEvent as o, setupKeyboardListeners as s };
